module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [(_vm.title) ? _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.programs), function(program) {
    return [_c('v-list-tile', {
      key: program.id,
      on: {
        "click": function($event) {
          return _vm.$emit("selected", program)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(program.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(program.start_date)) + " - " + _vm._s(_vm.dateformat(program.end_date)) + "\n        ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div=" + (program.id))
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db63fd86","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Physitrack/ProgramList.vue
// module id = 1535
// module chunks = 9